import { createSlice } from "@reduxjs/toolkit";
import {
  createJobPosting,
  fetchJobPostings,
  fetchSingleJobPosting,
  updateJobPosting,
  changeJobPostingStatus,
  deleteJobPosting,
} from "./jobPostingThunk";

const initialState = {
  jobs: [],
  singleJob: null,
  loading: false,
  total: 0,
  page: 1,
  pages: 1,
  error: null,
};

const jobPostingSlice = createSlice({
  name: "jobPosting",
  initialState,
  reducers: {
    clearSingleJob: (state) => {
      state.singleJob = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createJobPosting.pending, (state) => {
        state.loading = true;
      })
      .addCase(createJobPosting.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs.unshift(action.payload.data);
      })
      .addCase(createJobPosting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchJobPostings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJobPostings.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pages = action.payload.pages;
      })
      .addCase(fetchJobPostings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSingleJobPosting.fulfilled, (state, action) => {
        state.singleJob = action.payload.data;
      })

      .addCase(updateJobPosting.fulfilled, (state, action) => {
        const index = state.jobs.findIndex(
          (job) => job._id === action.payload.data._id,
        );
        if (index !== -1) {
          state.jobs[index] = action.payload.data;
        }
      })
      .addCase(changeJobPostingStatus.fulfilled, (state, action) => {
        const index = state.jobs.findIndex(
          (job) => job._id === action.payload.data._id,
        );
        if (index !== -1) {
          state.jobs[index] = action.payload.data;
        }
      })

      .addCase(deleteJobPosting.fulfilled, (state, action) => {
        state.jobs = state.jobs.filter((job) => job._id !== action.meta.arg);
      });
  },
});

export const { clearSingleJob } = jobPostingSlice.actions;
export default jobPostingSlice.reducer;
